import PropTypes from 'prop-types';
import { Box, styled } from '@mui/joy';

// import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';

import { Button } from '@mui/joy'

export const BottomTabBar = styled(
  Box,
  {
    slot: 'root',
    name: 'BottomTabBar'
  }
)(({ theme }) => ({
  '@media (min-width: 600px)': {
    display: 'none'
  },
  background: theme.palette.background.default,
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'stretch',
  borderTop: '1pt solid ' + theme.palette.divider,
}))


export function BottomTabBarTabLink({
  children,
  to,
  icon,
  ...props
}) {
  const Icon = icon
  // const location = useLocation()
  const isActive = location.pathname.indexOf(to) !== -1

  return (
    <Button
      as={Link}
      style={{ 
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        textDecoration: 'none',
        padding: '8px 12pt',
        flex: 1,
        textAlign: 'center', 
      }}
      color={isActive ? "primary" : "neutral"}
      variant={isActive ? 'solid' : "plain"}
      to={to}
      {...props}
    >
      {icon && <Icon size={38} />}
      {children}
    </Button>
  )
}

BottomTabBarTabLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  icon: PropTypes.func
}
